import React from "react";

import "./toggleButton.css";

const ToggleButton = ({ className, checked, setChecked }) => {
  return (
    <label className={`switch ${className}`}>
      <input
        type="checkbox"
        defaultChecked={checked}
        onChange={() => setChecked(!checked)}
      />
      <span className="slider round"></span>
    </label>
  );
};

export default ToggleButton;
